module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12Avuno/images/Cover.jpg?1735274501480",
      "alt": "This image is the cover for the book Haunted Weatherford, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted Weatherford, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A phantom stagecoach materializes on Weatherford's Main Street, the galloping hooves of invisible horses tugging witnesses back towards the nineteenth century. A stroll through the enchanting Chandor Gardens might lead to an encounter with its creator, renowned English portrait artist Douglas Chandor. The apparition of a former judge lingers around Parker County Courthouse, while the Old Jail Museum's corridors are filled with disembodied voices and echoing footsteps. Visitors to Old Greenwood Cemetery might hear the quiet sobbing of the woman who was murdered by a jealous lover or feel a cold nudge against their hands when they pass by a canine buried alongside his owner. Author Teal Gray walks through miles of Weatherford's history to unwind years of its haunted lore.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Teal Gray\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Teal Gray is a best-selling native Texan author and sacred site traveler. She is an ordained minister fascinated with world religions and their varying belief systems. Teal has used her gift of intuition and mediumship to help many paranormal investigative teams at sacred sites and historic buildings and homes around the world. Through these many experiences, she has amassed a greater understanding of the unknown. Sharing that knowledge is her passion. Ever curious, she hopes to make your reading experience feel like you are on the trail of answers with her.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0